// extracted by mini-css-extract-plugin
module.exports = {"container":"Feature_container__2AmOf","unavailable":"Feature_unavailable__2b-v8"};